import qs from 'query-string';
import type { ContestCreateResponse } from '@betterpool/api-types/contests-service';

import { nextApiAuthServiceInstance } from '~/domains/services/nextApi.instance';
import { contestsServiceInstance } from '~/domains/contest/domains/services/contest.service.instance';
import type { BRANDS } from '~/domains/auth/consts';

import type { APIField } from '../domains/common/fields/types/main';
import type { APISection } from '../domains/common/sections/types';
import type { QueryParams } from '../domains/common/api/settings/types/query.params';

export const getManageContestData = async (
  contestId: string,
  brand: BRANDS,
  authToken?: string
) => {
  const response = await contestsServiceInstance.get(
    `/contest-metadata/${contestId}/restart-contest-data?brand=${brand}`,
    {
      headers: authToken ? { Authorization: `Bearer ${authToken}` } : undefined,
    }
  );

  return response.data;
};

export const getManageEndpointData = async <
  R extends APIField | APIField[] | APISection | APISection[],
>(
  endpoint: string,
  payload: Record<string, unknown>,
  method: 'GET' | 'POST' = 'GET',
  abortController?: AbortController,
  queryParams?: QueryParams
): Promise<R> => {
  const queryString = `?${qs.stringify(queryParams)}`;

  const response = await nextApiAuthServiceInstance.request<R>({
    url: `/contest/manage/restart/${endpoint}${queryString}`,
    signal: abortController?.signal,
    method,
    ...(method === 'GET'
      ? {
          params: payload,
        }
      : {
          data: payload,
        }),
  });

  return response.data;
};

export const postManageContest = async (payload: Record<string, unknown>) => {
  const response = await nextApiAuthServiceInstance.post<ContestCreateResponse>(
    '/contest/manage/restart/new',
    payload
  );

  return response.data;
};
